import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import _map from 'lodash/map';
import _get from 'lodash/get';

import es from 'src/assets/i18n/es.json';
import pt from 'src/assets/i18n/pt.json';
import fr from 'src/assets/i18n/fr.json';

@Pipe({
  name: 'arrayTranslate'
})
export class ArrayTranslatePipe implements PipeTransform {

  constructor (
    private translateService: TranslateService
  ) {}

  transform(arr: any[], block: string): any[] {
    if (arr instanceof Array && block) {
      if (this.translateService.currentLang === 'es') {
        return _map(arr, (i) => ({
          ...i,
          label: _get(es, [block, i.label], i.label)
        }));
      } 
      else if (this.translateService.currentLang === 'pt') {
        return _map(arr, (i) => ({
          ...i,
          label: _get(pt, [block, i.label], i.label)
        }));
      }
      else if (this.translateService.currentLang === 'fr') {
        return _map(arr, (i) => ({
          ...i,
          label: _get(fr, [block, i.label], i.label)
        }));
      }

      else {
        return arr;
      }
    }

    return arr;
  }

}
